import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles';

const ModalHistorialComponent = (props) => {
    const historial = props.historial

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70%',
        height: 570,
        bgcolor: '#FFFFFF',
        boxShadow: 24,
        p: 4,
        color: 'black',
        borderRadius: '8px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const [openModalCompra, setOpenModalCompra] = React.useState(true);

    const handleCloseModal = () => {
        setOpenModalCompra(false)
        props.setOpenModalCompra.setOpenModalCompra()
    }

    const columns = [
        { field: 'pedido', headerName: 'No. Pedido', headerAlign: 'center', flex: .5 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', flex: .5 },
        { field: 'prefijo', headerName: 'Prefijo', headerAlign: 'center', flex: .5 },
        { field: 'folioInicial', headerName: 'Folio inicial', headerAlign: 'center', flex: .5 },
        { field: 'folioFinal', headerName: 'Folio final', headerAlign: 'center', flex: .5 },
        { field: 'observaciones', headerName: 'Observaciones', headerAlign: 'center', flex: 1.5 }
    ]

    const rows = [];
    historial?.map(anexo => {
        if (anexo?.prefijo != '') {
            rows.push({
                id: uuidv4(), pedido: anexo?.idcomprahologramas, prefijo: anexo?.prefijo,
                folioInicial: anexo?.folioinicial, folioFinal: anexo?.foliofinal,
                fecha: anexo?.fechaatendida?.substring(0, 10), observaciones: anexo?.observaciones
            })
        }
        else return null
    })


    const modalComponent = () => {
        return (
            <Modal open={openModalCompra}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <Typography id="modal-modal-title" className='text-danger'>
                        <h3 style={{ color: "#072036", fontFamily: "Montserrat", fontWeight: "bold", textAlign: 'center' }}>DETALLE DE COMPRA</h3>
                    </Typography>
                    <Typography id="modal-modal-description" component="h2">
                        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                disableColumnMenu={true}
                                pageSize={8}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)',
                                    '& .MuiDataGrid-cell': {
                                        display: 'block',
                                        position: 'relative',
                                        textAlign: 'center',
                                        paddingTop: '15px',
                                        paddingBottom: '15px',
                                        paddingLeft: 0,
                                        paddingRight: 0
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#0C365A',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '20px'
                                    }
                                }}
                            />
                        </Box>
                    </Typography>
                    <Typography sx={{ mt: 2, textAlign: 'center' }}>
                        <ThemeProvider theme={theme}>
                            <Button variant="contained" color="primary" style={{ width: '50%' }} onClick={() => handleCloseModal()}>Aceptar</Button>
                        </ThemeProvider>
                    </Typography>
                </Box>
            </Modal>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalHistorialComponent)
